'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EventRelay = require('../../core/EventRelay');

var _memoizeOne = require('react-utils/memoizeOne');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _UIModalDialog = require('../UIModalDialog');

var _UIModalDialog2 = _interopRequireDefault(_UIModalDialog);

var _UIFullScreen = require('../UIFullScreen');

var _UIFullScreen2 = _interopRequireDefault(_UIFullScreen);

var _getTransitionProps = require('./getTransitionProps');

var _getTransitionProps2 = _interopRequireDefault(_getTransitionProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AbstractModal = function (_Component) {
  _inherits(AbstractModal, _Component);

  function AbstractModal(props) {
    _classCallCheck(this, AbstractModal);

    var _this = _possibleConstructorReturn(this, (AbstractModal.__proto__ || Object.getPrototypeOf(AbstractModal)).call(this, props));

    _this._closeStartRelay = (0, _EventRelay.makeEventRelay)();
    _this._openCompleteRelay = (0, _EventRelay.makeEventRelay)();
    _this._getTransitionProps = (0, _memoizeOne2.default)(_getTransitionProps2.default);
    return _this;
  }

  _createClass(AbstractModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          componentName = _props.componentName,
          _contextual = _props._contextual,
          ModalDialog = _props.ModalDialog,
          onOpenStart = _props.onOpenStart,
          onOpenComplete = _props.onOpenComplete,
          onCloseStart = _props.onCloseStart,
          onCloseComplete = _props.onCloseComplete,
          Transition = _props.Transition,
          rest = _objectWithoutProperties(_props, ['componentName', '_contextual', 'ModalDialog', 'onOpenStart', 'onOpenComplete', 'onCloseStart', 'onCloseComplete', 'Transition']);

      var sandboxed = _contextual || this.context.sandboxed;

      var renderedModalDialog = _react2.default.createElement(ModalDialog, _extends({}, rest, {
        contextual: _contextual,
        _openCompleteRelay: sandboxed ? null : this._openCompleteRelay,
        _closeStartRelay: sandboxed ? null : this._closeStartRelay
      }));

      return sandboxed ? renderedModalDialog : _react2.default.createElement(
        _UIFullScreen2.default,
        {
          'data-layer-for': componentName,
          Transition: Transition,
          transitionProps: this._getTransitionProps(onOpenStart, this._openCompleteRelay.getHandle(onOpenComplete), this._closeStartRelay.getHandle(onCloseStart), onCloseComplete)
        },
        renderedModalDialog
      );
    }
  }]);

  return AbstractModal;
}(_react.Component);

exports.default = AbstractModal;

if (process.env.NODE_ENV !== 'production') {
  AbstractModal.propTypes = {
    componentName: _propTypes2.default.string.isRequired,
    _contextual: _propTypes2.default.bool,
    ModalDialog: _propTypes2.default.elementType.isRequired,
    onOpenStart: _propTypes2.default.func,
    onOpenComplete: _propTypes2.default.func,
    onCloseStart: _propTypes2.default.func,
    onCloseComplete: _propTypes2.default.func,
    Transition: _propTypes2.default.elementType
  };
}

AbstractModal.contextTypes = {
  sandboxed: _propTypes2.default.bool
};

AbstractModal.defaultProps = {
  ModalDialog: _UIModalDialog2.default
};

AbstractModal.displayName = 'AbstractModal';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/internal/AbstractModal.js
// module id = 546
// module chunks = 177